export default "__VITE_ASSET__27c2dbe7__"